import React from 'react';

import Card from "@mui/joy/Card";
import BaseApi from "../../utils/BaseApi";
import dayjs from "dayjs";
import {b64toBlob, downloadBlob} from "../../utils/misc";
import DownloadIcon from "@mui/icons-material/Download";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import Typography from "@mui/joy/Typography";
import {Stack} from "@mui/joy";


class PresentationCard extends React.Component {

    async downloadPresenation(){
        const api = new BaseApi();
        const url = `presentation/${this.props.presentation.id}/generate/`;
        let params = {download: true}
        let response = await api.get(url, params);
        let timestamp = dayjs().format('YYYYMMDDHHmmss');
        downloadBlob(
            b64toBlob(response.data),
            `CIFRA_Presentation_${this.props.presentation.id}_${timestamp}.pptx`,
            'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        )
    }

    render() {
        return (
            <Card
                size={'sm'}
            >
                <Stack
                    direction={'row'}
                    spacing={1}
                    alignItems="center"
                    flexWrap={'nowrap'}
                >
                    <Typography>{this.props.presentation.title}</Typography>
                    <CommonCallBackButton
                        presentation={this.props.presentation}
                        callBack={this.downloadPresenation.bind(this)}
                        propsObject={'presentation'}
                        propsObjectKey={'id'}
                        icon={DownloadIcon}
                    />
                </Stack>

            </Card>
        )
    }
}

export default PresentationCard